import React, { useContext, useEffect, useMemo, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { SocketContext } from '../../context/SocketContext'
import { serverApi } from '../../api'

import { useHideMenu } from '../../hooks/useHideMenu'
import { useGetPantallas } from '../../hooks/useGetPantallas'
import { UseSweetAlert } from '../../hooks/useSweetAlert'
import { getUsuarioStorage } from '../../helpers/getUsuarioStorage'
import { getPendientes } from '../../helpers/gePendientes'

// import { TablaTicketsPendientes } from './components/tablaTicketsPendientes';
import { ListTicketsPausados } from './components/listTicketsPausados'
import { ListTicketsReclasificados } from './components/listTicketsReclasificados'
import LoadingOverlay from '../../components/LoadingOverlay'
import { NoAcceso } from '../../components/NoAcceso'
import { NoCargaModulo } from '../../components/NoCargaModulo'
import { SelectElement } from '../../components/selectElement2'
import { Form } from 'react-bootstrap'
import { EditaDatosCliente } from './components/EditaDatosCliente'
import { ModalReclasificar } from './components/ModalReclasificar'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { ListTicketsPendientes } from './components/listTicketsPendientes'



// import logo from "../assets/logo.png";

const MySwal = withReactContent(Swal);
const sweet = (title, html, icon) => { MySwal.fire({ title, html, icon, confirmButtonColor: 'var(--color-primario)', timer: 15000 }) }

// const sweetConfirm = ( title, html, icon ) =>{  
//     return MySwal.fire({ 
//                     title, 
//                     html, 
//                     icon, 
//                     confirmButtonText: 'Ok',
//                     confirmButtonColor: 'var(--color-primario)',  
//                     showCancelButton: true, 
//                     cancelButtonColor: '#d33',  
//                     cancelButtonText: 'Cancelar' 
//                 }) 
// }

export const Modulo = () => {

    const usuario = useMemo(() => getUsuarioStorage(), []);
    const pantallas = useGetPantallas();
    const [modulo, setModulo] = useState(null);
    const [moduloTraslado, setModuloTraslado] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showModalReclasificar, setShowModalReclasificar] = useState(false);
    const [cantidadPausados, setCantidadPausados] = useState(0);
    const [cantidadReclasificados, setCantidadReclasificados] = useState(0);

    const [atencionIniciada, setAtencionIniciada] = useState(false);
    const [segundos, setSegundos] = useState(0);


    const navigate = useNavigate();
    useEffect(() => {
        if (usuario.uidUsuario === null) {
            // return <Navigate to="/ingreso" />
            navigate("/Ingreso")
        }

    }, [usuario.uidUsuario, navigate])



    useHideMenu(false);


    const { socket } = useContext(SocketContext);

    const [ticket, setTicket] = useState(null);
    const [pendientes, setPendientes] = useState([]);
    const ticketCargadoRef = useRef(false);
    const [tiposAsignados, setTiposAsignados] = useState(() => {
        const raw = localStorage.getItem('tiposAtencion');
        return raw ? raw.split(',') : null;
    });

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {

        const codigoEntidad = localStorage.getItem("codigoEntidad");
        const codigoUbicacion = localStorage.getItem("codigoUbicacion");

        if (!codigoEntidad || !codigoUbicacion) return;

        const fetch = async () => {
            try {

                const resp = await serverApi.post(`/modulos/select-modulos-traslado`, { codigoEntidad, codigoUbicacion });
                console.log(resp);


                const opciones = resp.data.listaModulos.map((item) => ({ value: item.uidModulo, label: ` ${item.moduloClase.toUpperCase()} - ${item.modulo.toUpperCase()} ` }))
                setModulo(opciones)

            } catch (error) {
                console.error("Error al obtener clases Modulos", error);
            } finally {

            }
        };

        fetch();
        console.log(cantidadPausados)

    }, [usuario])


    // Si el módulo se cerró sin terminar el ticket, recuperarlo al volver a abrir
    useEffect(() => {

        if (!usuario.codigoEntidad || !usuario.codigoUbicacion || !usuario.uidModulo || !usuario.uidUsuario) return;

        const recuperaAtencion = async () => {
            try {

                const resp = await serverApi.post(`/tickets/en-atencion`, {
                    codigoEntidad: usuario.codigoEntidad,
                    codigoUbicacion: usuario.codigoUbicacion,
                    uidModulo: usuario.uidModulo,
                    uidUsuario: usuario.uidUsuario
                });

                if (resp.data.ok && resp.data.ticket && !ticketCargadoRef.current) {
                    ticketCargadoRef.current = true;
                    setTicket(resp.data.ticket);
                    setAtencionIniciada(!!resp.data.ticket.atendidoEn || resp.data.ticket.estado === 'ATENDIENDO');
                    console.log("♻️ Ticket en atención recuperado:", resp.data.ticket);
                }

            } catch (error) {
                console.error("Error al recuperar ticket en atención", error);
            }
        };

        recuperaAtencion();

    }, [usuario])




    useEffect(() => {

        async function fetchData() {

            const formData = {
                codigoEntidad: usuario.codigoEntidad,
                uidModulo: usuario.uidModulo,
                uidUsuario: usuario.uidUsuario,
                codigoUbicacion: usuario.codigoUbicacion
            }
            try {

                const resp = await serverApi.post(`/tipos-atencion/busca-por-modulo`, formData);


                const aten = await resp.data.atenciones.filter((item) => item.checked === true);
                const asignados = aten.map((item) => item.uidTipoAtencion);
                localStorage.setItem('tiposAtencion', asignados);
                setTiposAsignados(asignados);

            } catch (error) {
                console.error("Error al obtener ubicaciones", error);
            }


        }

        fetchData();

    }, [usuario])


    // LLamar los tickets pendientes
    useEffect(() => {
        if (!tiposAsignados) return;

        const getPendiente = async () => {

            const tickets = await getPendientes();
            const filteredArray = tickets.filter(item => tiposAsignados.indexOf(item.uidTipoAtencion) >= 0);

            setPendientes(filteredArray);
        };

        getPendiente();

    }, [tiposAsignados])

    useEffect(() => {
        if (!socket) return;


        // console.log("✅ 1. El socket ya existe. Registrando listener 'tickets-pendientes'...");

        const cargarPendientes = (pend) => {
            // Este log es la prueba de fuego: si sale, el mensaje llegó del servidor
            console.log("📩 2. ¡Mensaje recibido! Datos:", pend);

            if (tiposAsignados) {
                const filteredArray = pend.filter(item => tiposAsignados.indexOf(item.uidTipoAtencion) >= 0);

                // console.log("🔍 3. Tickets filtrados para mostrar:", filteredArray.length);
                setPendientes(filteredArray);
            } else {
                console.warn("⚠️ No hay 'tiposAtencion' en localStorage, el mensaje llegó pero no se filtró nada.");
            }
        };

        socket.on('tickets-pendientes', cargarPendientes);

        return () => {
            console.log("♻️ Limpiando listener 'tickets-pendientes'...");
            socket?.off('tickets-pendientes', cargarPendientes);
        }
    }, [socket, tiposAsignados]);


    useEffect(() => {

        let interval;
        if (atencionIniciada) {
            // Reiniciar cuando cambia el ticket
            setSegundos(0);
            interval = setInterval(() => {
                setSegundos((prev) => prev + 1);
            }, 1000);
        }

        return () => { clearInterval(interval) };

    }, [atencionIniciada]);

    const formatearTiempo = (totalSegundos) => {

        const horas = Math.floor(totalSegundos / 3600);
        const minutos = Math.floor((totalSegundos % 3600) / 60);
        const segundosRestantes = totalSegundos % 60;

        return [
            horas.toString().padStart(2, '0'),
            minutos.toString().padStart(2, '0'),
            segundosRestantes.toString().padStart(2, '0')
        ].join(':');

    };


    const btn = useMemo(() => {

        const hayTicket = !!ticket?.uidTicketFlujo;

        return {
            siguiente: pendientes.length > 0,

            // Solo si hay ticket y aún no inició
            iniciar: hayTicket && !atencionIniciada,

            pausar: hayTicket && !atencionIniciada,

            reclasificar: hayTicket,

            // Solo si hay ticket y la atención inició
            rellamar: hayTicket && !atencionIniciada,
            terminar: hayTicket,

            // Solo si inició + permite traslado + módulo seleccionado
            transferir:
                hayTicket &&
                atencionIniciada &&
                ticket?.permiteTraslado === 1 &&
                !!moduloTraslado
        };

    }, [
        pendientes,
        ticket,
        atencionIniciada,
        moduloTraslado
    ]);

    const handelDataFromTable = (ticket) => {
        ticketCargadoRef.current = true;
        setTicket(ticket);
        setAtencionIniciada(false);
    }

    const siguienteTicket = async () => {
        // 1. Evitar llamadas si ya está cargando
        if (isLoading) return;

        // 2. Obtener el ID del ticket que estamos atendiendo actualmente desde el estado
        // Si no hay ticket (primer ticket del día), mandamos null o vacío
        const ticketActualId = ticket?.uidTicketFlujo || null;

        setIsLoading(true);

        const formData = {
            codigoEntidad: usuario.codigoEntidad,
            codigoUbicacion: usuario.codigoUbicacion,
            uidModulo: usuario.uidModulo,
            uidUsuario: usuario.uidUsuario,
            agente: usuario.agente,
            ticketAnterior: ticketActualId
        }
        try {

            const resp = await serverApi.post(`/tickets/siguiente-ticket`, formData);
            const ticket = resp.data;


            setIsLoading(false);

            if (ticket.ok) {
                // Actualizamos el estado con el nuevo ticket (o null si no hay más)
                ticketCargadoRef.current = true;
                setTicket(ticket.ticket);
                setAtencionIniciada(false);


                if (!ticket.ticket) {
                    console.log("No hay más tickets en espera");
                }
            } else {
                console.error("Error al llamar ticket:", ticket.error);
            }


        } catch (error) {
            console.error("Error al obtener ubicaciones", error);
        } finally {
            setModuloTraslado(null);
        }

    };

    const iniciaAtencion = async () => {
        // 1. Evitar llamadas si ya está cargando
        if (isLoading) return;

        // 2. Obtener el ID del ticket que estamos atendiendo actualmente desde el estado
        // Si no hay ticket (primer ticket del día), mandamos null o vacío
        const ticketActualId = ticket?.uidTicketFlujo || null;

        setIsLoading(true);

        const formData = {
            codigoEntidad: usuario.codigoEntidad,
            codigoUbicacion: usuario.codigoUbicacion,
            uidModulo: usuario.uidModulo,
            uidUsuario: usuario.uidUsuario,
            agente: usuario.agente,
            uidTicketFlujo: ticketActualId
        }
        try {

            const resp = await serverApi.post(`/tickets/inicia-atencion-ticket`, formData);
            const ticket = resp.data;


            setIsLoading(false);

            if (ticket.ok) {
                setAtencionIniciada(true);

            } else {
                console.error("Error al llamar ticket:", ticket.error);
            }


        } catch (error) {
            console.error("Error al obtener ubicaciones", error);
        } finally {
            setModuloTraslado(null);
        }

    };

    const pausarTicket = async () => {
        // 1. Evitar llamadas si ya está cargando
        if (isLoading) return;

        // 2. Obtener el ID del ticket que estamos atendiendo actualmente desde el estado
        // Si no hay ticket (primer ticket del día), mandamos null o vacío
        const ticketActualId = ticket?.uidTicketFlujo || null;

        setIsLoading(true);

        const formData = {
            codigoEntidad: usuario.codigoEntidad,
            codigoUbicacion: usuario.codigoUbicacion,
            uidModulo: usuario.uidModulo,
            uidUsuario: usuario.uidUsuario,
            agente: usuario.agente,
            uidTicketFlujo: ticketActualId
        }
        try {

            const resp = await serverApi.post(`/tickets/pausar-ticket`, formData);
            const ticket = resp.data;



            if (ticket.ok) {
                setTicket(null);
                setAtencionIniciada(false);

            } else {
                console.error("Error al llamar ticket:", ticket.error);
            }


        } catch (error) {
            console.error("Error al obtener ubicaciones", error);
        } finally {
            setModuloTraslado(null);
            setIsLoading(false);

        }

    };



    const volverLlamar = async (nombrePaciente, numeroTicket, uidTicketFlujo) => {

        const formData = {
            codigoEntidad: usuario.codigoEntidad,
            uidModulo: usuario.uidModulo,
            codigoUbicacion: usuario.codigoUbicacion,
            uidTicketFlujo: uidTicketFlujo
        }

        try {
            setIsLoading(true);
            const resp = await serverApi.post(`/tickets/volver-llamar`, formData);
            const ticket = resp.data;

            setIsLoading(false);

            if (ticket.ok) {
                // Actualizamos el estado con el nuevo ticket (o null si no hay más)
                console.log("Ticket actualizado: ", ticket.ticket);
            } else {
                console.error("Error al llamar ticket:", ticket.error);
            }


        } catch (error) {
            console.error("Error al obtener ubicaciones", error);
        }


    }

    const terminarTicket = async () => {

        const ticketActualId = ticket?.uidTicketFlujo || '';
        if (ticketActualId === '') {
            return UseSweetAlert('Atención!', 'No tiene Ticket cargado', 'warning')
        }

        const formData = {
            codigoEntidad: usuario.codigoEntidad,
            uidModulo: usuario.uidModulo,
            uidUsuario: usuario.uidUsuario,
            agente: usuario.agente,
            codigoUbicacion: usuario.codigoUbicacion,
            ticketAnterior: ticketActualId
        }
        try {

            const resp = await serverApi.post(`/tickets/terminar-ticket`, formData);
            const ticket = resp.data;

            setIsLoading(false);

            if (ticket.ok) {
                // Actualizamos el estado con el nuevo ticket (o null si no hay más)
                setTicket(null);
                setAtencionIniciada(false);

            } else {
                console.error("Error al llamar ticket:", ticket.error);
            }


        } catch (error) {
            console.error("Error al obtener ubicaciones", error);
        } finally {
            setModuloTraslado(null);
        }
    }

    const trasladarTicket = async () => {

        const ticketActual = ticket?.uidTicketFlujo || '';
        if (ticketActual === '') {
            return UseSweetAlert('Atención!', 'No tiene Ticket cargado', 'warning')
        }

        if (!moduloTraslado) {
            return UseSweetAlert('Atención!', 'Seleccione el destino', 'warning')
        }

        const formData = {
            codigoEntidad: usuario.codigoEntidad,
            uidModulo: usuario.uidModulo,
            uidUsuario: usuario.uidUsuario,
            agente: usuario.agente,
            codigoUbicacion: usuario.codigoUbicacion,
            uidTicketFlujo: ticketActual,
            moduloTraslado: moduloTraslado.value
        }
        try {
            setIsLoading(true);
            const resp = await serverApi.post(`/tickets/trasladar-ticket`, formData);
            const ticket = resp.data;


            if (ticket.ok) {
                // Actualizamos el estado con el nuevo ticket (o null si no hay más)
                setTicket(null);
                setAtencionIniciada(false);

            } else {
                console.error("Error al llamar ticket:", ticket.error);
            }


        } catch (error) {
            console.error("Error al obtener ubicaciones", error);
        } finally {
            setModuloTraslado(null);
            setIsLoading(false);
        }
    }

    const reclasificarTicket = async (nuevoUidTipoAtencion) => {
        const ticketActualId = ticket?.uidTicketFlujo || '';
        if (ticketActualId === '') {
            return UseSweetAlert('Atención!', 'No tiene Ticket cargado', 'warning');
        }

        const formData = {
            codigoEntidad: usuario.codigoEntidad,
            codigoUbicacion: usuario.codigoUbicacion,
            uidModulo: usuario.uidModulo,
            uidUsuario: usuario.uidUsuario,
            agente: usuario.agente,
            uidTicketFlujo: ticketActualId,
            nuevoUidTipoAtencion
        };

        try {
            setIsLoading(true);
            const resp = await serverApi.post(`/tickets/reclasificar-ticket`, formData);
            const resData = resp.data;

            if (resData.ok) {
                setTicket(null);
                setAtencionIniciada(false);
                setShowModalReclasificar(false);
                sweet('Éxito', 'Ticket reclasificado correctamente', 'success');
            } else {
                console.error("Error al reclasificar ticket:", resData.error);
                sweet('Error', resData.error || 'No se pudo reclasificar el ticket', 'error');
            }
        } catch (error) {
            console.error("Error al reclasificar ticket", error);
        } finally {
            setIsLoading(false);
            setShowModalReclasificar(false);
            setModuloTraslado(null);
        }
    };



    const registraDatosCliente = async (info) => {

        console.log(info);

        const codigoEntidad = usuario.codigoEntidad;
        if (!codigoEntidad || codigoEntidad === null) return sweet('Atención!', 'Revise la infromación', 'error');


        try {

            setIsLoading(true);
            const res = await serverApi.post(
                `/tickets/registra-cliente`,
                {
                    ...info,
                    codigoEntidad,
                }
            );

            console.log(res.data);

            if (res.data.ok === false) {
                sweet('', res.data.resp, 'error');
            } else {
                sweet('', res.data.resp, 'success');
                setShowModal(false)
                ticket.nombrePaciente = info.nombre1?.toUpperCase() + ' ' + info.nombre2?.toUpperCase() + ' ' + info.apellido1?.toUpperCase() + ' ' + info.apellido2?.toUpperCase()
            }




        } catch (error) {
            // sweet('Atención!', res[1], 'error');
            console.error(error);
        } finally {
            setIsLoading(false);

        }



    }


    if (usuario.uidUsuario === null) {
        return (
            <>
            </>
        )
    } else if (usuario.uidModulo === null) {
        return (<NoCargaModulo />)
    }
    else if (!pantallas.includes("escritorios")) {
        return (<NoAcceso />)
    } else {

        return (
            < >
                {isLoading && <LoadingOverlay />}
                <div
                    className={`container-fluid py-3 px-3 bg-light ${isLoading ? 'opacity' : ''}`}
                    style={{ minHeight: '100vh' }}
                >
                    {/* <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-3">

                        <div>
                            <h2 className="fw-bold mb-1">{usuario.modulo}</h2>

                            <div className="text-muted small">
                                {usuario.ubicacion}
                            </div>
                        </div>

                        <div className="text-end">
                            <div className="fs-1 fw-bold">
                                {new Date().toLocaleTimeString()}
                            </div>

                            <div className="text-muted">
                                {new Date().toLocaleDateString()}
                            </div>
                        </div>

                    </div> */}

                    <div className='row '>
                        {/* <div className="mt-1 col-lg-4 col-12">
                            <img id="imgPrint" style={{height:'auto',width:'100%'}} src={ logo } alt=''/>
                        </div> */}

                        {/* <div className="mt-1 col-lg-7 col-12">
                            <h2><span>{ usuario.agente }</span></h2>
                            <h4> Modulo: <span className='text-success'>{ usuario.modulo }</span> </h4>
                        </div> */}


                    </div>

                    <div
                        className="row g-3 mb-4 "
                        style={{ minHeight: 130 }}
                    >

                        {
                            pendientes?.map((item) => (

                                <div className="col-xl-2 col-md-3 col-6" key={item.uidTipoAtencion}>

                                    <div
                                        className="bg-white rounded-4 shadow-sm p-3 h-80 border"
                                        style={{ minHeight: 80 }}
                                    >

                                        <div className="d-flex align-items-center gap-1 mb-1">

                                            <div
                                                className="rounded-circle"
                                                style={{
                                                    width: 12,
                                                    height: 12,
                                                    backgroundColor: item.color
                                                }}
                                            />

                                            <div className="fw-semibold small text-truncate">
                                                {item.sigla}
                                            </div>

                                        </div>

                                        <div
                                            className="fw-bold"
                                            style={{
                                                fontSize: '2rem',
                                                color: item.color
                                            }}
                                        >
                                            {item.cantidadTickets}
                                        </div>

                                    </div>

                                </div>
                            ))
                        }

                    </div>



                    <div className="row g-4">
                        <div className="col-xl-5">
                            <div className="bg-white rounded-4 shadow-sm border p-4 h-100">

                                <div className="d-flex justify-content-between align-items-center mb-1">
                                    <h4 className="fw-bold mb-0">Atención Actual</h4>
                                    {ticket?.uidTicketFlujo && (

                                        <>

                                            <div className="text-center mb-1">

                                                {atencionIniciada && (
                                                    <div className="text-center ">

                                                        <div
                                                            style={{
                                                                fontSize: "1.4rem",
                                                                fontWeight: "bold",
                                                                color: "#FFC107",
                                                                fontFamily: "monospace"
                                                            }}
                                                        >
                                                            ⏱ {formatearTiempo(segundos)}
                                                        </div>

                                                    </div>

                                                )}
                                            </div>

                                        </>
                                    )}
                                </div>

                                {
                                    ticket?.uidTicketFlujo ? (

                                        <>

                                            <div className="text-center mb-0">

                                                <button
                                                    type="button"
                                                    onClick={() => setShowModal(true)}
                                                    className="border-0 bg-transparent p-0 text-center w-100"
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <div
                                                        className="fw-bold text-success"
                                                        style={{ fontSize: '2rem' }}
                                                    >
                                                        {ticket.codigoTipoAtencion}-{ticket.numeroTicket}
                                                    </div>

                                                    <div className="mt-0 fs-6 fw-bold">
                                                        {ticket.numeroDocumento}
                                                        {
                                                            ticket.nombrePaciente && ticket.nombrePaciente.trim() !== '' && (
                                                                <span> - {ticket.nombrePaciente}</span>
                                                            )
                                                        }
                                                    </div>

                                                    <div
                                                        className="text-muted mt-0"
                                                        style={{ "fontSize": "x-small" }}
                                                    >
                                                        {ticket.tipoAtencion}
                                                    </div>
                                                </button>


                                            </div>

                                            {ticket?.permiteTraslado === 1 &&

                                                <div className="mb-1">

                                                    <Form.Label>Transferir a:</Form.Label>

                                                    <SelectElement
                                                        options={modulo}
                                                        name={'modulo'}
                                                        isMulti={false}
                                                        closeOnMenuSelect={true}
                                                        value={moduloTraslado}
                                                        onChange={(selected) => {
                                                            setModuloTraslado(selected)
                                                        }}
                                                        isClearable={false}
                                                    />

                                                </div>

                                            }


                                        </>

                                    ) : (

                                        <div className="text-center text-muted py-4">
                                            Sin atención activa
                                        </div>
                                    )
                                }

                                <div className="row mt-4 g-3">


                                    <div className="col-md-4">
                                        <button
                                            className="btn btn-info text-white w-100 fw-bold"
                                            style={{
                                                height: 60,
                                                borderRadius: 18,
                                                opacity: !btn.siguiente ? 0.4 : 1
                                            }}
                                            onClick={siguienteTicket}
                                            disabled={!btn.siguiente}
                                        >
                                            Siguiente
                                        </button>
                                    </div>

                                    <div className="col-md-4">
                                        <button
                                            className="btn btn-success w-100 fw-bold"
                                            style={{
                                                background: '#9DDFAF',
                                                height: 60,
                                                borderRadius: 18,
                                                opacity: !btn.iniciar ? 0.4 : 1
                                            }}
                                            onClick={iniciaAtencion}
                                            disabled={!btn.iniciar}

                                        >
                                            Iniciar
                                        </button>
                                    </div>

                                    <div className="col-md-4">
                                        <button
                                            className="btn w-100 fw-bold"
                                            style={{
                                                background: '#A78BFA',
                                                color: 'white',
                                                height: 60,
                                                borderRadius: 18,
                                                border: 'none',
                                                boxShadow: '0 6px 14px rgba(0,0,0,.15)',
                                                opacity: !btn.pausar ? .4 : 1,
                                                transition: 'all .3s'
                                            }}
                                            onClick={pausarTicket}
                                            disabled={!btn.pausar}
                                        >
                                            <div className="d-flex flex-column">
                                                <span style={{ fontSize: '1.2rem' }}>
                                                    ⏸
                                                </span>

                                                <span>
                                                    Pausar
                                                </span>
                                            </div>
                                        </button>
                                    </div>

                                    <div className="col-md-4">
                                        <button
                                            className="btn btn-primary w-100 fw-bold"
                                            style={{
                                                height: 60,
                                                borderRadius: 18,
                                                opacity: !btn.rellamar ? 0.4 : 1
                                            }}
                                            onClick={() => volverLlamar(
                                                ticket.nombrePaciente,
                                                ticket.numeroTicket,
                                                ticket.uidTicketFlujo
                                            )}
                                            disabled={!btn.rellamar}
                                        >
                                            Re-llamar
                                        </button>
                                    </div>

                                    <div className="col-4">
                                        <button
                                            className="btn w-100 fw-bold text-white"
                                            style={{
                                                background: '#FD7E14',
                                                height: 60,
                                                borderRadius: 18,
                                                border: 'none',
                                                boxShadow: '0 6px 14px rgba(0,0,0,.15)',
                                                opacity: !btn.reclasificar ? 0.4 : 1,
                                                transition: 'all .3s'
                                            }}
                                            onClick={() => setShowModalReclasificar(true)}
                                            disabled={!btn.reclasificar}
                                        >
                                            Reclasificar
                                        </button>
                                    </div>

                                    {/* {ticket?.permiteTraslado === 1 &&  */}

                                    <div className="col-4">
                                        <button
                                            className="btn btn-warning w-100 text-dark fw-bold"
                                            style={{
                                                background: '#F9E1A8',
                                                height: 60,
                                                borderRadius: 18,
                                                opacity: !btn.transferir ? 0.4 : 1

                                            }}
                                            onClick={trasladarTicket}
                                            disabled={!btn.transferir}

                                        >
                                            Transferir
                                        </button>
                                    </div>
                                    {/* } */}



                                    <div className="col-md-12">
                                        <button
                                            className="btn btn-danger w-100 fw-bold"
                                            style={{
                                                height: 60,
                                                borderRadius: 18,
                                                opacity: !btn.terminar ? 0.4 : 1
                                            }}
                                            onClick={terminarTicket}
                                            disabled={!btn.terminar}
                                        >
                                            Terminar
                                        </button>
                                    </div>



                                </div>

                            </div>

                        </div>

                        <div className="col-xl-7">

                            <div
                                className="bg-white rounded-4 shadow-sm border p-4"
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    height: 450,
                                    overflow: 'hidden'
                                }}
                            >

                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h5 className="fw-bold mb-0">Cola de Espera</h5>

                                </div>

                                <ListTicketsPendientes
                                    usuario={usuario}
                                    dataFromTable={handelDataFromTable}
                                    ticketActual={ticket?.uidTicketFlujo ?? null}
                                    tiposAsignados={tiposAsignados}
                                />



                            </div>

                        </div>

                    </div>

                    <div className="row g-4">

                        <div className="col-xl-6 ">

                            <div className='bg-white rounded-4 shadow-sm border p-4 mt-3 col-12' style={{ display: 'flex', flexDirection: 'column', height: 340 }}>
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h4 className="fw-bold mb-0">Tickets Pausados</h4>

                                </div>
                                <ListTicketsPausados
                                    usuario={usuario}
                                    dataFromTable={handelDataFromTable}
                                    ticketActual={ticket?.uidTicketFlujo ?? null}
                                    setCantidadPausados={setCantidadPausados}
                                    tiposAsignados={tiposAsignados}
                                />
                            </div>

                        </div>

                        <div className="col-xl-6 ">

                            <div className='bg-white rounded-4 shadow-sm border p-4 mt-3 col-12' style={{ display: 'flex', flexDirection: 'column', height: 340 }}>
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h4 className="fw-bold mb-0">Tickets Reclasificados</h4>

                                </div>
                                <ListTicketsReclasificados
                                    usuario={usuario}
                                    dataFromTable={handelDataFromTable}
                                    ticketActual={ticket?.uidTicketFlujo ?? null}
                                    setCantidadReclasificados={setCantidadReclasificados}
                                    tiposAsignados={tiposAsignados}
                                />
                            </div>

                        </div>

                    </div>






                </div>

                <EditaDatosCliente
                    show={showModal}
                    onClose={() => setShowModal(false)}
                    onSave={(datos) => registraDatosCliente(datos)}
                    ticket={ticket}
                />

                <ModalReclasificar
                    show={showModalReclasificar}
                    onClose={() => setShowModalReclasificar(false)}
                    onConfirm={(nuevoUidTipoAtencion) => reclasificarTicket(nuevoUidTipoAtencion)}
                    ticket={ticket}
                    usuario={usuario}
                />
            </>
        )
    }
}
